import { useMemo } from 'react'

import { useMutation } from '@tanstack/react-query'

import { useApi } from '@tabeeb/modules/shared/utils/API'

import { useDispatch } from '@tabeeb/store'
import { onAddErrorNotification, onAddSuccessNotification } from '@tabeeb/modules/notification/actions'

const useUsersUpload = () => {
  const dispatch = useDispatch()

  const { mainApi: api } = useApi()

  const createUsersMutation = useMutation({
    mutationFn: api.adminUsers.postCreateUsersAsync,
    onError: () => {
      dispatch(onAddErrorNotification({ message: 'Failed to upload users' }))
    },
    onSuccess: (response) => {
      if (response.AddedToDatabase && !response.CreatedUserList?.length) {
        dispatch(
          onAddSuccessNotification({ message: `${response.CreatedUserList!.length} users were successfully uploaded` })
        )
      }
    },
  })

  return useMemo(
    () => ({
      loading: createUsersMutation.isLoading,
      errors: createUsersMutation.data?.ErroredUserList?.map((e) => e.Message)?.filter((m) => m) ?? [],
      onUploadAsync: createUsersMutation.mutateAsync,
      onReset: createUsersMutation.reset,
    }),
    [
      createUsersMutation.data?.ErroredUserList,
      createUsersMutation.isLoading,
      createUsersMutation.mutateAsync,
      createUsersMutation.reset,
    ]
  )
}

export default useUsersUpload
